"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeAxios = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _axios = _interopRequireDefault(require("axios"));

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

// eslint-disable-next-line no-restricted-imports

/**
 * Replicates the axios 0.19 default params serialization behavior:
 * - Arrays: key[]=val1&key[]=val2
 * - Nested objects: key=JSON.stringify(value)
 * - Dates: key=date.toISOString()
 * - null/undefined values are skipped
 *
 * This is needed because axios 0.28 changed the default serialization to use
 * deep bracket notation (e.g. filters[state][]=reported) instead of
 * JSON.stringifying nested objects (e.g. filters={"state":["reported"]}).
 *
 * To opt out for a specific call and use custom serialization,
 * pass an explicit paramsSerializer object:
 * e.g. { paramsSerializer: { serialize: (p) => qs.stringify(p, { arrayFormat: 'brackets' }) } }
 */
function legacySerializeParams(params) {
  var parts = [];
  Object.entries(params).forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    if (val === null || val === undefined) return;
    var values = Array.isArray(val) ? val : [val];
    var encodedKey = Array.isArray(val) ? "".concat(key, "[]") : key;
    values.forEach(function (v) {
      if (v instanceof Date) {
        v = v.toISOString();
      } else if ((0, _typeof2.default)(v) === 'object' && v !== null) {
        v = JSON.stringify(v);
      }

      parts.push("".concat(encodeURIComponent(encodedKey), "=").concat(encodeURIComponent(String(v))));
    });
  });
  return parts.join('&');
}

var initializeAxios = function initializeAxios() {
  _axios.default.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': (0, _csrfToken.csrfToken)()
  };

  _axios.default.interceptors.request.use(function (config) {
    // Backward-compatible params serialization (matching axios 0.19 behavior).
    // Skipped when a per-request paramsSerializer is explicitly provided.
    if (config.params && !config.paramsSerializer) {
      var _config$url, _config$url2;

      var separator = (_config$url = config.url) !== null && _config$url !== void 0 && _config$url.includes('?') ? '&' : '?';
      config.url = ((_config$url2 = config.url) !== null && _config$url2 !== void 0 ? _config$url2 : '') + separator + legacySerializeParams(config.params);
      config.params = undefined;
    } // Set baseURL at request time


    var appState = (0, _globals.default)('appState');

    if (!config.baseURL) {
      var communityUrl = (0, _globals.default)('communityUrl');

      if (appState !== null && appState !== void 0 && appState.isEmbedded) {
        var _appState$baseUrl;

        config.baseURL = (_appState$baseUrl = appState.baseUrl) !== null && _appState$baseUrl !== void 0 ? _appState$baseUrl : communityUrl;
      } else if (communityUrl && (0, _globals.default)('application') !== 'control') {
        config.baseURL = communityUrl;
      }
    }

    return config;
  });
};

exports.initializeAxios = initializeAxios;